// be aware of tailwind's default sm: breakpoints when changing this breakpoint
export const MOBILE_BREAKPOINT = 640;
export const UHD_WIDTH_BREAKPOINT = 1925